import styled, { css } from 'styled-components';
import { media } from 'src/config/breakpoints';

export const AuthLogInLinkContainer = styled.div`
  margin-top: 1.25rem;

  ${media.w.between.px576.px992(css`
    text-align: center;
  `)};
`;
